import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pdf-zoom-in',
  templateUrl: './pdf-zoom-in.component.html',
  styleUrls: ['./pdf-zoom-in.component.css']
})
export class PdfZoomInComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
